module.exports = __webpack_public_path__ + "media/images/emblems/Vilters-Wang-blazono-f753260f31a93d2d4833961cbfde144d.png";